<div class="container" mat-dialog-content>
    <h1 mat-dialog-title>Import Contacts</h1>

    <mat-form-field appearance="fill">
        <mat-label>Import From</mat-label>
        <mat-select [(value)]="selectedSource">
            <mat-option *ngFor="let source of sources" [value]="source.value">
                {{source.name}}
            </mat-option>
        </mat-select>
    </mat-form-field>


    <ng-container>
        <ngx-dropzone (change)="onSelect($event)">
            <ngx-dropzone-label>Drop csv for processing</ngx-dropzone-label>
            <ngx-dropzone-preview *ngFor="let f of files" [removable]="true">
                <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
            </ngx-dropzone-preview>
        </ngx-dropzone>
    </ng-container>

</div>

<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
</div>